var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "101px",
    height: "101px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.5291005291005292s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.46296296296296297s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(80 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.39682539682539686s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.3306878306878307s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(160 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.2645502645502646s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(200 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.19841269841269843s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.1322751322751323s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(280 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "-0.06613756613756615s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(320 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 23.5,
    rx: 5.5,
    ry: 2.5,
    width: 11,
    height: 5,
    fill: "#38cab3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.5952380952380952s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.d3265e21ff6a4c10b314de453da0da3e.svg";
export { ForwardRef as ReactComponent };